import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  CheckboxStyled,
  StyledInput,
  StyledLabel,
  StyledBox,
} from './styles/CheckboxStyled';

class Checkbox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { elementId, getRef, text } = this.props;

    return (
      <CheckboxStyled>
        <StyledInput type="checkbox" id={elementId} ref={getRef} />
        <StyledLabel htmlFor={elementId}>{text}</StyledLabel>
        <StyledBox />
      </CheckboxStyled>
    );
  }
}

Checkbox.propTypes = {
  elementId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  getRef: PropTypes.func,
};

Checkbox.defaultProps = {
  getRef: Function.prototype,
};

export default Checkbox;
